var map = {
	"./API/ApiTokenManager": 138,
	"./API/ApiTokenManager.vue": 138,
	"./API/Index": 556,
	"./API/Index.vue": 556,
	"./Acquiring/Dashboard": 557,
	"./Acquiring/Dashboard.vue": 557,
	"./Acquiring/Devices": 558,
	"./Acquiring/Devices.vue": 558,
	"./Acquiring/Payments": 559,
	"./Acquiring/Payments.vue": 559,
	"./Acquiring/Taxes": 560,
	"./Acquiring/Taxes.vue": 560,
	"./Acquiring/Transactions": 561,
	"./Acquiring/Transactions.vue": 561,
	"./Acquiring/components/ValuesCard": 139,
	"./Acquiring/components/ValuesCard.vue": 139,
	"./AuthorizedTransactions/Index": 562,
	"./AuthorizedTransactions/Index.vue": 562,
	"./Boleto/Form": 563,
	"./Boleto/Form.vue": 563,
	"./Boleto/Index": 564,
	"./Boleto/Index.vue": 564,
	"./Boleto/Receipt": 73,
	"./Boleto/Receipt.vue": 73,
	"./Boleto/Ticket": 140,
	"./Boleto/Ticket.vue": 140,
	"./Boleto/View": 565,
	"./Boleto/View.vue": 565,
	"./Card/AcceptTerms": 554,
	"./Card/AcceptTerms.vue": 554,
	"./Card/ConclusionTheCard": 141,
	"./Card/ConclusionTheCard.vue": 141,
	"./Card/ConfirmationAddress": 566,
	"./Card/ConfirmationAddress.vue": 566,
	"./Card/Index": 567,
	"./Card/Index.vue": 567,
	"./Card/PasswordCreate": 568,
	"./Card/PasswordCreate.vue": 568,
	"./Card/RequestsList": 569,
	"./Card/RequestsList.vue": 569,
	"./Card/StepProgressBar": 570,
	"./Card/StepProgressBar.vue": 570,
	"./Card/components/CardFisico": 142,
	"./Card/components/CardFisico.vue": 142,
	"./Card/components/CardVirtual": 143,
	"./Card/components/CardVirtual.vue": 143,
	"./Card/components/CardsCarrosel": 144,
	"./Card/components/CardsCarrosel.vue": 144,
	"./Card/components/ModalPassword": 98,
	"./Card/components/ModalPassword.vue": 98,
	"./Card/components/SlideSeparator": 145,
	"./Card/components/SlideSeparator.vue": 145,
	"./Card/myCard": 571,
	"./Card/myCard.vue": 571,
	"./Contact/Form": 553,
	"./Contact/Form.vue": 553,
	"./Contact/Index": 572,
	"./Contact/Index.vue": 572,
	"./Contact/OperatingLimits": 146,
	"./Contact/OperatingLimits.vue": 146,
	"./Crypto/ActionButtons": 54,
	"./Crypto/ActionButtons.vue": 54,
	"./Crypto/Balance": 45,
	"./Crypto/Balance.vue": 45,
	"./Crypto/Deposit/Index": 573,
	"./Crypto/Deposit/Index.vue": 573,
	"./Crypto/Extract/Index": 574,
	"./Crypto/Extract/Index.vue": 574,
	"./Crypto/SpotPrice/Index": 575,
	"./Crypto/SpotPrice/Index.vue": 575,
	"./Crypto/SpotPrice/Logo": 181,
	"./Crypto/SpotPrice/Logo.vue": 181,
	"./Crypto/Trade/Buy": 576,
	"./Crypto/Trade/Buy.vue": 576,
	"./Crypto/Trade/Index": 555,
	"./Crypto/Trade/Index.vue": 555,
	"./Crypto/Trade/Sell": 577,
	"./Crypto/Trade/Sell.vue": 577,
	"./Crypto/Wallets/Dialogs": 149,
	"./Crypto/Wallets/Dialogs.vue": 149,
	"./Crypto/Wallets/Wallets": 578,
	"./Crypto/Wallets/Wallets.vue": 578,
	"./Crypto/Withdraw/Index": 579,
	"./Crypto/Withdraw/Index.vue": 579,
	"./Crypto/Withdraw/Request": 580,
	"./Crypto/Withdraw/Request.vue": 580,
	"./Crypto/Withdraw/WithdrawModal": 150,
	"./Crypto/Withdraw/WithdrawModal.vue": 150,
	"./Crypto/components/CardCurrency": 99,
	"./Crypto/components/CardCurrency.vue": 99,
	"./Crypto/components/DatePicker": 148,
	"./Crypto/components/DatePicker.vue": 148,
	"./Crypto/components/DropdownSelect": 65,
	"./Crypto/components/DropdownSelect.vue": 65,
	"./Crypto/components/Icons": 43,
	"./Crypto/components/Icons.vue": 43,
	"./Crypto/components/ItemValue": 147,
	"./Crypto/components/ItemValue.vue": 147,
	"./Crypto/components/Label": 55,
	"./Crypto/components/Label.vue": 55,
	"./Crypto/components/MenuCripto": 75,
	"./Crypto/components/MenuCripto.vue": 75,
	"./Crypto/components/PriceCrypto": 96,
	"./Crypto/components/PriceCrypto.vue": 96,
	"./Crypto/components/SearchBar": 100,
	"./Crypto/components/SearchBar.vue": 100,
	"./Crypto/components/TextField": 86,
	"./Crypto/components/TextField.vue": 86,
	"./Crypto/utils/cryptoAmountFormat": 133,
	"./Crypto/utils/cryptoAmountFormat.js": 133,
	"./Crypto/utils/icons": 42,
	"./Crypto/utils/icons.js": 42,
	"./Crypto/utils/maskInputWithCommaAndDots": 83,
	"./Crypto/utils/maskInputWithCommaAndDots.js": 83,
	"./Crypto/utils/numberFormat": 32,
	"./Crypto/utils/numberFormat.js": 32,
	"./Dashboard": 581,
	"./Dashboard.vue": 581,
	"./Dashboard/Index": 582,
	"./Dashboard/Index.vue": 582,
	"./Dashboard/Kibana": 583,
	"./Dashboard/Kibana.vue": 583,
	"./Extract/Index": 584,
	"./Extract/Index.vue": 584,
	"./Limits/Index": 585,
	"./Limits/Index.vue": 585,
	"./MobileApp/FirstAccess": 586,
	"./MobileApp/FirstAccess.vue": 586,
	"./MobileApp/MobileApplicationAuthentication": 151,
	"./MobileApp/MobileApplicationAuthentication.vue": 151,
	"./MobileApp/MobileApplicationAuthorization": 152,
	"./MobileApp/MobileApplicationAuthorization.vue": 152,
	"./MobileApp/Show": 587,
	"./MobileApp/Show.vue": 587,
	"./Onboarding/CheckRequest": 588,
	"./Onboarding/CheckRequest.vue": 588,
	"./Onboarding/OnboardingAccess": 589,
	"./Onboarding/OnboardingAccess.vue": 589,
	"./Onboarding/ValidateEmail": 590,
	"./Onboarding/ValidateEmail.vue": 590,
	"./Payment/Index": 591,
	"./Payment/Index.vue": 591,
	"./Payment/Show": 592,
	"./Payment/Show.vue": 592,
	"./Pix/CopiaCola": 153,
	"./Pix/CopiaCola.vue": 153,
	"./Pix/Form": 593,
	"./Pix/Form.vue": 593,
	"./Pix/Index": 594,
	"./Pix/Index.vue": 594,
	"./PixPdvExchange/Confirm": 154,
	"./PixPdvExchange/Confirm.vue": 154,
	"./PixPdvExchange/CustomerData": 155,
	"./PixPdvExchange/CustomerData.vue": 155,
	"./PixPdvExchange/CustomerForm": 156,
	"./PixPdvExchange/CustomerForm.vue": 156,
	"./PixPdvExchange/Form": 157,
	"./PixPdvExchange/Form.vue": 157,
	"./PixPdvExchange/Index": 595,
	"./PixPdvExchange/Index.vue": 595,
	"./PixPdvExchange/Show": 158,
	"./PixPdvExchange/Show.vue": 158,
	"./PixWallet/Index": 596,
	"./PixWallet/Index.vue": 596,
	"./Profile/DeleteUserForm": 159,
	"./Profile/DeleteUserForm.vue": 159,
	"./Profile/LogoutOtherBrowserSessionsForm": 160,
	"./Profile/LogoutOtherBrowserSessionsForm.vue": 160,
	"./Profile/Show": 597,
	"./Profile/Show.vue": 597,
	"./Profile/Terms/Index": 598,
	"./Profile/Terms/Index.vue": 598,
	"./Profile/Terms/Terms": 163,
	"./Profile/Terms/Terms.vue": 163,
	"./Profile/TwoFactorAuthenticationForm": 137,
	"./Profile/TwoFactorAuthenticationForm.vue": 137,
	"./Profile/UpdatePasswordForm": 161,
	"./Profile/UpdatePasswordForm.vue": 161,
	"./Profile/UpdatePersonDataformationForm": 599,
	"./Profile/UpdatePersonDataformationForm.vue": 599,
	"./Profile/UpdateProfileInformationForm": 162,
	"./Profile/UpdateProfileInformationForm.vue": 162,
	"./QrCode/Form": 600,
	"./QrCode/Form.vue": 600,
	"./QrCode/Index": 601,
	"./QrCode/Index.vue": 601,
	"./QrCode/View": 602,
	"./QrCode/View.vue": 602,
	"./Receipt/Fake": 603,
	"./Receipt/Fake.vue": 603,
	"./Receipt/Receipt": 87,
	"./Receipt/Receipt.vue": 87,
	"./Receipt/Show": 604,
	"./Receipt/Show.vue": 604,
	"./ReportError/Form": 605,
	"./ReportError/Form.vue": 605,
	"./Select/Index": 606,
	"./Select/Index.vue": 606,
	"./Send/BetweenAccounts/FormValueDetails": 164,
	"./Send/BetweenAccounts/FormValueDetails.vue": 164,
	"./Send/BetweenAccounts/Index": 607,
	"./Send/BetweenAccounts/Index.vue": 607,
	"./Send/BetweenAccounts/SelectFavored": 165,
	"./Send/BetweenAccounts/SelectFavored.vue": 165,
	"./Send/Index": 608,
	"./Send/Index.vue": 608,
	"./Send/Lots/Pix/Index": 609,
	"./Send/Lots/Pix/Index.vue": 609,
	"./Send/Lots/Pix/Payments": 166,
	"./Send/Lots/Pix/Payments.vue": 166,
	"./Send/Lots/Pix/ValueDetails": 168,
	"./Send/Lots/Pix/ValueDetails.vue": 168,
	"./Send/Lots/Ted/Index": 610,
	"./Send/Lots/Ted/Index.vue": 610,
	"./Send/Lots/Ted/Payments": 169,
	"./Send/Lots/Ted/Payments.vue": 169,
	"./Send/Lots/Ted/ValueDetails": 170,
	"./Send/Lots/Ted/ValueDetails.vue": 170,
	"./Send/Pix/FormValueDetails": 171,
	"./Send/Pix/FormValueDetails.vue": 171,
	"./Send/Pix/Index": 611,
	"./Send/Pix/Index.vue": 611,
	"./Send/Pix/SelectKey": 172,
	"./Send/Pix/SelectKey.vue": 172,
	"./Send/PixCopyPaste/FormValueDetails": 173,
	"./Send/PixCopyPaste/FormValueDetails.vue": 173,
	"./Send/PixCopyPaste/Index": 612,
	"./Send/PixCopyPaste/Index.vue": 612,
	"./Send/PixCopyPaste/SelectKey": 174,
	"./Send/PixCopyPaste/SelectKey.vue": 174,
	"./Send/Receipt": 613,
	"./Send/Receipt.vue": 613,
	"./Send/Ted/FormValueDetails": 175,
	"./Send/Ted/FormValueDetails.vue": 175,
	"./Send/Ted/Index": 614,
	"./Send/Ted/Index.vue": 614,
	"./Send/Ted/SelectFavored": 176,
	"./Send/Ted/SelectFavored.vue": 176,
	"./Send/components/AccountsTable": 102,
	"./Send/components/AccountsTable.vue": 102,
	"./Send/components/ButtonIcon": 167,
	"./Send/components/ButtonIcon.vue": 167,
	"./Send/components/Favored": 39,
	"./Send/components/Favored.vue": 39,
	"./Send/components/FormSummary": 77,
	"./Send/components/FormSummary.vue": 77,
	"./Send/components/FormValues": 66,
	"./Send/components/FormValues.vue": 66,
	"./Send/components/InputWithButton": 103,
	"./Send/components/InputWithButton.vue": 103,
	"./Send/components/LotItem": 78,
	"./Send/components/LotItem.vue": 78,
	"./Send/components/RegisteredList": 101,
	"./Send/components/RegisteredList.vue": 101,
	"./Send/components/RoundedIcon": 76,
	"./Send/components/RoundedIcon.vue": 76,
	"./Send/components/Slider": 56,
	"./Send/components/Slider.vue": 56,
	"./Send/components/TitleSection": 48,
	"./Send/components/TitleSection.vue": 48,
	"./Send/utils/utils": 61,
	"./Send/utils/utils.js": 61,
	"./Teams/Create": 615,
	"./Teams/Create.vue": 615,
	"./Teams/CreateTeamForm": 177,
	"./Teams/CreateTeamForm.vue": 177,
	"./Teams/DeleteTeamForm": 178,
	"./Teams/DeleteTeamForm.vue": 178,
	"./Teams/Show": 616,
	"./Teams/Show.vue": 616,
	"./Teams/TeamMemberManager": 179,
	"./Teams/TeamMemberManager.vue": 179,
	"./Teams/UpdateTeamNameForm": 180,
	"./Teams/UpdateTeamNameForm.vue": 180,
	"./Terms/Crypto": 617,
	"./Terms/Crypto.vue": 617,
	"./Transfer/Index": 618,
	"./Transfer/Index.vue": 618,
	"./Transfer/Receipt": 74,
	"./Transfer/Receipt.vue": 74,
	"./Transfer/Show": 619,
	"./Transfer/Show.vue": 619,
	"./Transfer/Ticket": 97,
	"./Transfer/Ticket.vue": 97,
	"./ValuesReceive/Index": 620,
	"./ValuesReceive/Index.vue": 620,
	"./ValuesReceive/List": 621,
	"./ValuesReceive/List.vue": 621,
	"./ValuesReceive/Withdrawal": 622,
	"./ValuesReceive/Withdrawal.vue": 622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 775;